import { routerGetCall } from '../../axios';

const getClaimDetails = (state, params) => {
  const url = `/account-services/claimDetails`;
  return routerGetCall(state, url, params);
};
export default { getClaimDetails };
